
document.addEventListener('DOMContentLoaded', function() {
  // Only run on product pages with [Pre-Order] in title
  var titleEl = document.querySelector('h1');
  if (!titleEl || titleEl.textContent.indexOf('[Pre-Order]') === -1) return;
  
  // Find the first active tab content
  var firstTab = document.querySelector('.content-tabs__content.is-active .rte');
  if (!firstTab) {
    // Try alternate selector
    firstTab = document.querySelector('.content-tabs__content:first-child .rte');
  }
  if (!firstTab) {
    // Try even broader
    firstTab = document.querySelector('[data-tab-content] .rte');
  }
  if (!firstTab) return;
  
  // Create notice element
  var notice = document.createElement('p');
  notice.style.cssText = 'color: #cc0000; font-weight: 600; margin-bottom: 10px; font-size: 14px;';
  notice.innerHTML = '\u{1F4E6} Pre-Order Item \u2014 Expected to ship by April 13, 2026.';
  
  // Insert at the beginning of the tab
  firstTab.insertBefore(notice, firstTab.firstChild);
});
